import React from "react";

export const TrustBar = () => (
  <div className="border-y border-zinc-800 bg-ink-surface" data-testid="trust-bar">
    <div className="max-w-7xl mx-auto px-4 py-2.5 flex flex-wrap justify-center md:justify-between gap-x-8 gap-y-1.5 text-[11px] uppercase font-bold text-zinc-400 tracking-wide">
      <span className="flex items-center gap-1.5"><span className="text-neon-green">✔</span> 100% légal · THC &lt; 0,3%</span>
      <span className="flex items-center gap-1.5"><span className="text-neon-green">📦</span> Pochon scellé anti-odeur</span>
      <span className="flex items-center gap-1.5"><span className="text-neon-magenta">🔬</span> Analyses laboratoire</span>
      <span className="flex items-center gap-1.5"><span className="text-neon-magenta">💶</span> Paiement à la remise : carte ou espèces</span>
    </div>
  </div>
);

const BLOCKS = [
  ["🛡️", "100% conforme & légal", "Certifié THC < 0,3% sous strict contrôle laboratoire. Produits du chanvre autorisés en France et UE."],
  ["🌿", "Chanvre bio sélectionné", "Cultures raisonnées sans pesticides, issues de fermes artisanales sélectionnées."],
  ["🤫", "Discrétion totale", "Pochon hermétique anti-odeur, remise en main propre avec code de réception."],
];

export const TrustFooter = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 py-10" data-testid="trust-footer">
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {BLOCKS.map(([icon, title, text]) => (
        <div key={title} className="flex items-start gap-3 bg-ink-surface border border-zinc-800 p-5">
          <span className="text-2xl">{icon}</span>
          <div>
            <h3 className="font-anton text-sm uppercase text-white leading-tight">{title}</h3>
            <p className="text-zinc-500 text-xs mt-1">{text}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);
